export default function Radio(theme) {
  return {
    MuiRadio: {
      styleOverrides: {
        root: {
          padding: theme.spacing(1),
          svg: {
            fontSize: '1.5rem',
            '&[font-size=small]': {
              fontSize: '1.25rem'
            }
          }
        }
      }
    }
  };
}
